import { render, staticRenderFns } from "./msNumber.vue?vue&type=template&id=a1a8b936&scoped=true"
import script from "./msNumber.vue?vue&type=script&lang=js"
export * from "./msNumber.vue?vue&type=script&lang=js"
import style0 from "./msNumber.vue?vue&type=style&index=0&id=a1a8b936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a8b936",
  null
  
)

export default component.exports